import { decorator } from './decorator';

export const bound = decorator({ method: { bind: true } });
